/**
 * Resolve item/media URLs so relative /public and /uploads paths hit the API in local dev.
 */
export function resolveMediaUrl(src) {
  if (!src || typeof src !== 'string') return src;
  const trimmed = src.trim();
  if (!trimmed) return trimmed;
  if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith('data:')) return trimmed;

  let baseUrl = process.env.REACT_APP_API_URL ?? (process.env.NODE_ENV === 'development' ? 'http://localhost:5164' : '');
  baseUrl = (baseUrl || '').trim().replace(/\/+$/, '');
  if (!baseUrl) return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;

  if (!/^https?:\/\//i.test(baseUrl)) baseUrl = `http://${baseUrl}`;
  return `${baseUrl}${trimmed.startsWith('/') ? trimmed : `/${trimmed}`}`;
}
